/* global process */
/* eslint no-process-env:0 */
import {createStore, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {routerMiddleware, syncHistoryWithStore} from 'react-router-redux';
import createLogger from 'redux-logger';
import fb from './middlewares/fb';
import reactions from './middlewares/reactions';
import routing from './middlewares/routing';
import metrics from './middlewares/metrics';
import metricsUserId from './middlewares/metricsUserId';
import actionsQueue from './modules/actionsQueue/middleware';
import initNow from '~/modules/now/init';
import {browserHistory} from 'react-router';
import reducer from './reducers/index';
import config from './config';
import getStorageValue from './misc/getStorageValue';
import safeJSONParse from './misc/safeJSONParse';
import preloadBrokers from '~/modules/brokers/preload';

const middlewares = [
  thunkMiddleware,
  routerMiddleware(browserHistory),
  reactions,
  metrics,
  metricsUserId,
  routing,
  actionsQueue,
  window.fbq && fb,
  (safeJSONParse(getStorageValue('debug')) || process.env.NODE_ENV === 'development')
    && createLogger({collapsed: true, duration: true, colors: false}),
].filter(value => value);
let store = null
if (config.env === 'test') {
  store = applyMiddleware(...middlewares)(createStore)(
    reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  );
} else {
  store = applyMiddleware(...middlewares)(createStore)(
    reducer
  );
}
const history = syncHistoryWithStore(browserHistory, store);
initNow(store);
preloadBrokers(store);

export default store;
export {history};



// WEBPACK FOOTER //
// ./src/store.js